<v4-custom-select
  [placeholder]="'word.time' | translate"
  [textItem]="textView"
  [showTextItem]="!!textView"
  [(visible)]="visible"
>
  <div class="v4-layout-dropdown w-[500px]">
    <div class="flex flex-row items-center justify-between">
      <nz-time-picker
        class="flex-1"
        [nzAllowEmpty]="false"
        [nzFormat]="'HH:mm'"
        [nzMinuteStep]="30"
        [(ngModel)]="timeStart"
        nzPlaceHolder="00:00"
        (ngModelChange)="onTimeChange()"
      ></nz-time-picker>
      <span class="separate mx-2">~</span>
      <nz-time-picker
        class="flex-1"
        [nzAllowEmpty]="false"
        [nzFormat]="'HH:mm'"
        [nzMinuteStep]="30"
        [(ngModel)]="timeEnd"
        nzPlaceHolder="23:59"
        (ngModelChange)="onTimeChange()"
      ></nz-time-picker>
    </div>
    <div class="py-6">
      <nz-slider
        nzRange
        [nzMin]="min"
        [nzMax]="max"
        [nzStep]="30"
        [(ngModel)]="sliderValue"
        [nzTipFormatter]="tipFormatter"
        (ngModelChange)="onSliderChange($event)"
      ></nz-slider>
    </div>
    <div class="flex flex-row items-center justify-between">
      <a nz-button nzType="link" (click)="onReset()">
        {{ "word.reset" | translate }}
        <!-- 重置筛选 -->
      </a>
      <div class="ml-auto">
        <button class="mr-3" nz-button nzSize="large">
          {{ "word.cancel" | translate }}
        </button>
        <button nz-button nzSize="large" nzType="primary" (click)="onConfirm()">
          {{ "word.confirm" | translate }}
          <!-- 确定 -->
        </button>
      </div>
    </div>
  </div>
</v4-custom-select>

<ng-template>
  <div class="host-range-time-picker">
    <div
      class="picker-selector whitespace-nowrap"
      nz-dropdown
      nzTrigger="click"
      [(nzVisible)]="visible"
      [nzBackdrop]="false"
      [nzDropdownMenu]="menu"
    >
      <span class="textview" [class.placeholder]="!textView">{{ textView || ("word.time" | translate) }}</span>
      <span class="down-arrow">
        <i nz-icon [nzType]="visible ? 'caret-up' : 'caret-down'" nzTheme="outline"></i>
      </span>
    </div>
    <nz-dropdown-menu #menu>
      <div class="range-time-picker-dropdown">
        <div class="dropdown-container">
          <div class="input-row">
            <nz-time-picker
              [nzAllowEmpty]="false"
              [nzFormat]="'HH:mm'"
              [nzMinuteStep]="30"
              [(ngModel)]="timeStart"
              nzPlaceHolder="00:00"
              (ngModelChange)="onTimeChange()"
            ></nz-time-picker>
            <span class="separate">~</span>
            <nz-time-picker
              [nzAllowEmpty]="false"
              [nzFormat]="'HH:mm'"
              [nzMinuteStep]="30"
              [(ngModel)]="timeEnd"
              nzPlaceHolder="23:59"
              (ngModelChange)="onTimeChange()"
            ></nz-time-picker>
          </div>
          <div class="range-row">
            <nz-slider
              nzRange
              [nzMin]="min"
              [nzMax]="max"
              [nzStep]="30"
              [(ngModel)]="sliderValue"
              [nzTipFormatter]="tipFormatter"
              (ngModelChange)="onSliderChange($event)"
            ></nz-slider>
          </div>
          <div class="bottom-row">
            <div class="center">
              <button nz-button>
                {{ "word.cancel" | translate }}
              </button>
              <button nz-button nzType="primary" (click)="onConfirm()">
                {{ "word.confirm" | translate }}
                <!-- 确定 -->
              </button>
            </div>
            <div class="right">
              <a href="javascript:void(0)" (click)="onReset()">
                {{ "word.reset_filter" | translate }}
                <!-- 重置筛选 -->
              </a>
            </div>
          </div>
        </div>
      </div>
    </nz-dropdown-menu>
  </div>
</ng-template>
